import React, { useState, useEffect } from 'react';
import api,{API_BASE_URL} from '../services/api.js';

const ApiTest = () => {
  const [status, setStatus] = useState('Testing...');
 const [workers, setWorkers] = useState([]);}

  /*useEffect(() => {
    const testApi = async () => {
      try {
        // Test health endpoint
        const healthResponse = await fetch(`${API_BASE_URL || 'http://localhost:8002/api'}/health`);
        if (!healthResponse.ok) throw new Error('Health check failed');
        
        // Test workers endpoint
        const workersData = await api.workers.getAll();
        setWorkers(workersData);
        setStatus(`✅ API Connected - Found ${workersData.length} workers`);
      } catch (error) {
        setStatus(`❌ API Error: ${error.message}`);
        console.error('API Test Error:', error);
      }
    };

    testApi();
  }, []);

  return (
    <div className="alert alert-info">
      <strong>API Status:</strong> {status}
      <br />
      <small>API URL: {API_BASE_URL || 'http://localhost:8002/api'}</small>
      {workers.length > 0 && (
        <div className="mt-2">
         <strong>Workers found:</strong> {workers.map(w => w.name).join(', ')} 
        </div>
      )}
    </div>
  );
};*/

export default ApiTest;